'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fbemitter = require('fbemitter');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeckoLoadingService = function () {
    _createClass(GeckoLoadingService, [{
        key: 'emitter',


        // 1 minute
        get: function get() {
            return GeckoLoadingService.emitter;
        },
        set: function set(value) {
            GeckoLoadingService.emitter = value;
        }
    }, {
        key: 'active',
        get: function get() {
            return GeckoLoadingService.active;
        },
        set: function set(value) {
            GeckoLoadingService.active = value;
        }
    }]);

    function GeckoLoadingService() {
        _classCallCheck(this, GeckoLoadingService);

        this.timeout = 60000;

        // Create modal event emitter (if not already created)
        if (!this.emitter) this.emitter = new _fbemitter.EventEmitter();
    }

    _createClass(GeckoLoadingService, [{
        key: 'show',
        value: function show() {
            if (!this.active) {
                this.active = true;
                this.emitter.emit('update');
            }
            return;
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (this.active) {
                this.active = false;
                this.emitter.emit('update');
            }
            return;
        }
    }, {
        key: 'resolve',
        value: function resolve(promise) {
            var _this = this;

            // Is promise?
            if (Promise.resolve(promise) !== promise) return;

            // Show loader
            this.show();

            // Hide loader timeout fallback
            var timeout = setTimeout(function () {
                return _this.hide();
            }, this.timeout);

            return new Promise(function (resolve, reject) {

                promise.then(function (values) {
                    //Hide loader
                    _this.hide();
                    //Resolve promise
                    resolve(values);
                    // Clear timeout
                    clearTimeout(timeout);
                });

                promise[promise.fail ? 'fail' : 'catch'](function (errors) {
                    //Hide loader
                    _this.hide();
                    //Reject promise
                    reject(errors);
                    // Clear timeout
                    clearTimeout(timeout);
                });
            });
        }
    }]);

    return GeckoLoadingService;
}();

GeckoLoadingService.active = false;
exports.default = GeckoLoadingService;